import { Card, CardBody, CardHeader } from 'reactstrap'
import { H5 } from '../../../../../AbstractElements'
import { NoDataFoundPropsType } from '../../../../../Type/Application/Contacts/Contacts'
import SearchNotFoundClass from './../PersonalTab/SearchNotFoundClass';
const NoDataFoundClass = ({ title }: NoDataFoundPropsType) => {
  return (
    <Card className="mb-0">
      <CardHeader className="d-flex">
        <H5>{title}</H5>
        <span className="f-14 pull-right mt-0">0 Contacts</span>
      </CardHeader>
      <CardBody>
       <SearchNotFoundClass />
      </CardBody>
    </Card>
  )
}

export default NoDataFoundClass